import {STRIPE_ERROR, STRIPE_SUCCESS, VIPPS_ERROR, VIPPS_SUCCESS} from 'new-constants/payment.constants';
import {SEND_ORDER_FAILURE, SEND_ORDER_SUCCESS} from 'new-constants/api.constants';
import {SET_CURRENT_RESTAURANT} from 'new-constants/app-state.constants';
import {DONE_INCOMPATIBLE_CART_CONFIRMATION} from 'new-constants/popup.constants';
import {PurchaseTokenState} from './purchase-token.reducer.types';
import {
    CANCEL_STRIPE_CARD_REGISTRATION, CANCEL_STRIPE_THREE_DS_POPUP,
    CANCEL_VIPPS_PAYMENT_FRAME
} from '../constants/popup.constants';
import {
    CHECK_ADYEN_PAYMENT_SUCCESS,
    CHECK_PAYMENT_STATUS_SUCCESS,
    INIT_ADYEN_PAYMENT_FAILURE,
    ORDER_SUCCESS,
    REPEAT_ORDER_SUCCESS, SUBMIT_APPLE_PAY_FAILURE, SUBMIT_APPLE_PAY_SUCCESS, SUBMIT_GOOGLE_PAY_FAILURE, SUBMIT_GOOGLE_PAY_SUCCESS
} from '../constants/api.constants';
import { SET_CURRENT_RESTAURANT_FROM_CART, START } from '../constants/app-state.constants';
import {PaymentStatuses} from "../constants/common.constants";
import { ADYEN_ERROR, ADYEN_SUCCESS } from '../constants/payment.constants';
import { MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP } from '../components/popups/error-message/ErrorMessage';

const initialState: PurchaseTokenState = Date.now();

export const purchaseTokenReducer = (previousState = initialState, action): PurchaseTokenState => {
	switch (action?.type) {
		case SET_CURRENT_RESTAURANT:
		case SET_CURRENT_RESTAURANT_FROM_CART:
			return Date.now();
			break;

		case SEND_ORDER_SUCCESS:
			if (action.payload.isOrderSent) {
				return Date.now();
			}

			return previousState;
			break;

		case SEND_ORDER_FAILURE:
			return Date.now();
			break;

		case STRIPE_SUCCESS:
		case VIPPS_SUCCESS:
		case STRIPE_ERROR:
		case VIPPS_ERROR:
		case ADYEN_ERROR:
		case ADYEN_SUCCESS:
        case SUBMIT_APPLE_PAY_SUCCESS:
        case SUBMIT_GOOGLE_PAY_SUCCESS:
        case SUBMIT_GOOGLE_PAY_FAILURE:
        case SUBMIT_APPLE_PAY_FAILURE:
        case CANCEL_STRIPE_THREE_DS_POPUP:
			return Date.now();
			break;

        case START:
            if (action.showPopup === MOBILE_PAY_RETURN_NO_URL_ERROR_MESSAGE_POPUP) {
                return Date.now();
            }
            return previousState;
            break;

		case CHECK_PAYMENT_STATUS_SUCCESS:
			if(!(action.payload.isAdyenOrder && (action.payload.data.status === PaymentStatuses.complete || action.payload.data.status === PaymentStatuses.cancelled))) {
				return previousState;
			}

			return Date.now();
			break;

		case CHECK_ADYEN_PAYMENT_SUCCESS:
			if(action.payload.data.resultCode !== PaymentStatuses.authorised) {
				return previousState;
			}

			return Date.now();
			break;

		case ORDER_SUCCESS:
			if (!(action.payload.isScheduledForCancel && action.payload.data.order.isPaid)) {
				return previousState;
			}

			return Date.now();
			break;

		case DONE_INCOMPATIBLE_CART_CONFIRMATION:
			return Date.now();
			break;

		case CANCEL_STRIPE_CARD_REGISTRATION:
		case CANCEL_VIPPS_PAYMENT_FRAME:
			return Date.now();
			break;

		case REPEAT_ORDER_SUCCESS:
			return Date.now();
			break;

		case INIT_ADYEN_PAYMENT_FAILURE:
			return Date.now();
			break;

		default:
			return previousState;
	}
};
